import MuiTableRow from '@mui/material/TableRow';
import { type ComponentProps, type ForwardedRef, forwardRef } from 'react';

export const TableRow = forwardRef(function CustomTableRow(
  { ...props }: ComponentProps<typeof MuiTableRow>,
  ref: ForwardedRef<HTMLTableRowElement>,
) {
  return <MuiTableRow ref={ref} {...props} />;
});
